
import {NfGlobalMessage} from "./NfGlobalMessage";
import type {NfMessage} from "./NfMessage";

/**
 * Wiadomość globalna pochodząca z konkretnego komponentu
 */
export class NfComponentGlobalMessage extends NfGlobalMessage {
    public componentMessage= true;
    public widgetId:number = -1;
    public serviceInstanceId:number = -1;
    public componentId:number = -1;
    public browserTabId:string = '';
    public uuid:number = -1;
    public static isSuperClassOf(message: NfMessage): message is NfComponentGlobalMessage {
        //@ts-ignore
        return NfGlobalMessage.isSuperClassOf(message) && message['componentMessage'] === true;
    }
}